import React, { useState } from "react";
import "./About.css";
import ScrollSection from "../../components/ScrollSection";
import { useContent } from "../../context/ContentContext";

function ResumeSection({ content }) {
  const { about, experience, education, certifications, skills } = content;

  return (
    <div className="resume-panel">
      <div className="resume-panel-header">
        <span>{content.hero.name}</span>
        <span className="resume-panel-title">{content.hero.title}</span>
      </div>

      <div className="resume-block">
        <h4 className="resume-block-title">Summary</h4>
        <p className="resume-summary-text">{about.summary}</p>
      </div>

      <div className="resume-block">
        <h4 className="resume-block-title">Technical Skills</h4>
        <div className="resume-skills-grid">
          {Object.entries(skills).map(([category, items]) => (
            <div key={category} className="resume-skill-group">
              <span className="resume-skill-category">{category}</span>
              <div className="resume-skill-tags">
                {items.map((skill) => (
                  <span key={skill} className="resume-skill-tag">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="resume-block">
        <h4 className="resume-block-title">Experience</h4>
        {experience.map((job) => (
          <div key={job.title} className="resume-job">
            <div className="resume-job-header">
              <span className="resume-job-title">{job.title}</span>
              <span className="resume-job-company">
                {job.company} · {job.period}
              </span>
            </div>
            <ul className="resume-job-bullets">
              {job.responsibilities.map((r, i) => (
                <li key={i}>{r}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="resume-block">
        <h4 className="resume-block-title">Education</h4>
        <div className="resume-job">
          <div className="resume-job-header">
            <span className="resume-job-title">{education.certificate}</span>
            <span className="resume-job-company">
              {education.school} · {education.year}
            </span>
          </div>
          <p className="resume-edu-desc">{education.description}</p>
        </div>
      </div>

      <div className="resume-block">
        <h4 className="resume-block-title">Certifications</h4>
        {certifications.map((cert, i) => (
          <div key={i} className="resume-cert">
            <span className="resume-cert-name">{cert.name}</span>
            <span className="resume-cert-meta">
              {cert.status
                ? cert.status + " · Expected " + cert.expected
                : cert.year}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function About() {
  const { content, loading } = useContent();
  const [showResume, setShowResume] = useState(false);

  if (loading || !content) return null;

  const { about } = content;

  return (
    <ScrollSection name="about">
      <div className="section-container">
        <h2
          className="section-title"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          About Me
        </h2>
        <div
          className="about-summary"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="200"
        >
          <i className="fas fa-quote-left about-quote-left"></i>
          <p>{about.summary}</p>
          <i className="fas fa-quote-right about-quote-right"></i>
          <div className="contact-resume">
            <button
              className="btn btn-primary"
              onClick={() => setShowResume(!showResume)}
            >
              {showResume ? "Hide Resume" : "View My Resume"}
            </button>
          </div>
        </div>

        {showResume && (
          <div
            className="resume-expand"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <ResumeSection content={content} />
          </div>
        )}

        <div
          className="about-grid"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="300"
        >
          {about.cards.map((card) => (
            <div className="about-card" key={card.title}>
              <i className={"about-icon fas fa-" + card.icon}></i>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </ScrollSection>
  );
}

export default About;
